export const GoogleMeetIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20150_1439)">
        <path
          d="M22.7871 22.5195C21.429 21.5964 21.4107 19.6282 22.7515 18.6808L33.7216 10.9297C35.3006 9.81425 37.5 10.9222 37.5 12.8347V28.0477C37.5 29.9406 35.3401 31.0527 33.7572 29.9766L22.7871 22.5195Z"
          fill="url(#paint0_linear_20150_1439)"
        />
        <path
          d="M2.5 15.1087C2.5 10.3543 6.41761 6.5 11.25 6.5H23.9773C26.1739 6.5 27.9545 8.25187 27.9545 10.413V29.587C27.9545 31.7481 26.1739 33.5 23.9773 33.5H6.47727C4.28062 33.5 2.5 31.7481 2.5 29.587V15.1087Z"
          fill="url(#paint1_radial_20150_1439)"
        />
        <mask
          id="mask0_20150_1439"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="4"
          y="11"
          width="26"
          height="28"
        >
          <path
            d="M4.09088 20.3909C4.09088 15.6366 8.0085 11.7822 12.8409 11.7822H25.5682C27.7648 11.7822 29.5454 13.5341 29.5454 15.6953V34.8692C29.5454 37.0304 27.7648 38.7822 25.5682 38.7822H8.06815C5.87151 38.7822 4.09088 37.0304 4.09088 34.8692V20.3909Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_20150_1439)">
          <g filter="url(#filter0_f_20150_1439)">
            <path
              d="M15.6063 20.6256L37.4813 8.26074V32.5216L15.6063 20.6256Z"
              fill="url(#paint2_linear_20150_1439)"
            />
          </g>
        </g>
        <path
          d="M8.46591 30.3699C10.0035 30.3699 11.25 29.1435 11.25 27.6307C11.25 26.118 10.0035 24.8916 8.46591 24.8916C6.9283 24.8916 5.68182 26.118 5.68182 27.6307C5.68182 29.1435 6.9283 30.3699 8.46591 30.3699Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_20150_1439"
          x="-12.3937"
          y="-19.7393"
          width="77.875"
          height="80.2607"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="14" result="effect1_foregroundBlur_20150_1439" />
        </filter>
        <linearGradient
          id="paint0_linear_20150_1439"
          x1="26.5227"
          y1="21.6508"
          x2="46.0909"
          y2="21.6508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6A100" />
          <stop offset="1" stopColor="#FFBE00" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_20150_1439"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.7919 20) rotate(180) scale(31.7635 26.5797)"
        >
          <stop offset="0.15" stopColor="#FFE921" />
          <stop offset="1" stopColor="#FEC700" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_20150_1439"
          x1="27.9983"
          y1="19.0842"
          x2="16.5198"
          y2="19.0579"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#FFB5E8" />
          <stop offset="1" stopColor="#FFDBF5" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_20150_1439">
          <rect width="35" height="27" fill="white" transform="translate(2.5 6.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
